import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

/** Ported from gpp-website blocking popup logo for matching dimensions. */
export const PricedUpCompliancePopupLogo = ({ className }: PropsType): React.ReactElement => (
    <SvgElement
        className={className}
        xmlns='http://www.w3.org/2000/svg'
        width='106'
        height='23'
        viewBox='0 0 106 23'
        fill='none'
    >
        <g clipPath='url(#pricedUpLogoIdA)'>
            <path
                d='M11.306 15.477a4.437 4.437 0 0 1-1.23 1.564c-.521.42-1.13.735-1.827.945a7.744 7.744 0 0 1-2.244.314H3.628v4.266H.5V8.348h5.81c.852 0 1.614.119 2.285.355.67.237 1.238.573 1.706 1.006.467.433.826.951 1.076 1.553.251.603.376 1.27.376 2.001v.04c0 .827-.149 1.55-.447 2.174Zm-2.722-2.153c0-.704-.226-1.239-.68-1.604-.454-.366-1.074-.55-1.859-.55H3.628v4.348h2.478c.785 0 1.395-.207 1.828-.62.433-.413.65-.924.65-1.534v-.04ZM22.702 22.567l-3.047-4.55h-2.458v4.55H14.07V8.347h6.5c1.693 0 3.01.414 3.951 1.24.94.827 1.412 1.977 1.412 3.453v.04c0 1.152-.282 2.09-.843 2.813-.563.725-1.297 1.257-2.204 1.595l3.473 5.078h-3.656v.001Zm.06-9.364c0-.678-.216-1.185-.65-1.524-.433-.338-1.035-.507-1.808-.507h-3.108v4.082h3.17c.771 0 1.363-.182 1.777-.548.413-.366.619-.854.619-1.463v-.04ZM28.898 22.567V8.347h3.127v14.22h-3.127ZM46.936 21.327a6.754 6.754 0 0 1-1.29.803 6.675 6.675 0 0 1-1.534.508 9.263 9.263 0 0 1-1.869.172 7.362 7.362 0 0 1-2.905-.568 7.136 7.136 0 0 1-2.315-1.555 7.068 7.068 0 0 1-1.524-2.326 7.491 7.491 0 0 1-.548-2.864v-.04c0-1.016.183-1.967.548-2.855a7.344 7.344 0 0 1 1.524-2.336 7.067 7.067 0 0 1 2.336-1.585c.907-.386 1.91-.578 3.006-.578.663 0 1.27.053 1.818.162a7.609 7.609 0 0 1 1.493.447c.448.19.86.42 1.24.691.378.271.73.569 1.056.894l-1.991 2.295a7.553 7.553 0 0 0-1.696-1.178c-.576-.285-1.222-.427-1.94-.427a3.93 3.93 0 0 0-2.965 1.3 4.45 4.45 0 0 0-.854 1.411 4.798 4.798 0 0 0-.304 1.716v.04c0 .61.101 1.186.304 1.727.203.542.484 1.016.843 1.422a3.911 3.911 0 0 0 2.975 1.32c.814 0 1.5-.148 2.063-.446a7.992 7.992 0 0 0 1.675-1.219l1.991 2.012c-.366.392-.745.744-1.137 1.056v.001ZM50.571 22.567V8.347h10.705v2.784h-7.617v2.884h6.703v2.783H53.66v2.985h7.718v2.783H50.571v.001ZM76.734 18.26a6.61 6.61 0 0 1-1.555 2.255 7.348 7.348 0 0 1-2.396 1.502c-.928.366-1.947.549-3.058.549H64.18V8.348h5.545c1.11 0 2.13.18 3.058.538.927.36 1.726.857 2.396 1.494a6.668 6.668 0 0 1 1.555 2.244c.365.86.548 1.79.548 2.793v.04a7.138 7.138 0 0 1-.548 2.804v-.001Zm-2.722-2.803a4.63 4.63 0 0 0-.315-1.727 4.061 4.061 0 0 0-.873-1.36 3.874 3.874 0 0 0-1.35-.884 4.684 4.684 0 0 0-1.748-.315H67.31v8.572h2.417c.636 0 1.22-.101 1.747-.304a3.749 3.749 0 0 0 1.35-.874c.373-.379.664-.825.874-1.34.21-.515.315-1.09.315-1.727v-.041Z'
                fill='#fff'
            />
            <path
                d='M82.778 7.36v8.45c0 2.195 1.108 3.237 2.802 3.237s2.824-1 2.824-3.128V7.361h4.258L85.592.508 78.52 7.36h4.258Z'
                fill='#F2C300'
            />
            <path
                d='M99.2 7.36h-6.539v8.429c0 3.887-1.777 6.052-4.679 6.777h8.894v-4.344h2.107c3.757 0 6.516-1.89 6.516-5.496v-.044c0-3.345-2.476-5.322-6.299-5.322Zm2.107 5.561c0 1.195-.934 1.999-2.41 1.999h-2.02V10.9h1.998c1.499 0 2.433.674 2.433 1.978v.042l-.001.001Z'
                fill='#F2C300'
            />
        </g>
        <defs>
            <clipPath id='pricedUpLogoIdA'>
                <path
                    fill='#fff'
                    transform='translate(.5 .508)'
                    d='M0 0h105v22.302H0z'
                />
            </clipPath>
        </defs>
    </SvgElement>
);
